import ExamScore from './ExamScore.gql';

export default ExamScore;
